<wvr-modal-component #animationRoot
  [themeVariant]="btnThemeVariant"
  [title]="title"
  [btnText]="btnText"
  [btnVisible]="btnVisible">
  <ng-content select="template[modal-body]" ngProjectAs="template[modal-body]"></ng-content>
  <ng-content select="template[modal-footer]" ngProjectAs="template[modal-footer]"></ng-content>
</wvr-modal-component>
